export default __webpack_public_path__ + "static/media/logo_square.8221a941.png";